import script from "./Snappy-Products.vue?vue&type=script&setup=true&lang=js"
export * from "./Snappy-Products.vue?vue&type=script&setup=true&lang=js"

import "./Snappy-Products.vue?vue&type=style&index=0&id=5ad8adcf&lang=css"
import "./Snappy-Products.vue?vue&type=style&index=1&id=5ad8adcf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad8adcf"]])

export default __exports__